import { render, staticRenderFns } from "./assignment-table.vue?vue&type=template&id=d3e16baa"
import script from "./assignment-table.vue?vue&type=script&lang=js"
export * from "./assignment-table.vue?vue&type=script&lang=js"
import style0 from "./assignment-table.vue?vue&type=style&index=0&id=d3e16baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports